<template>
  <div class="container">
    <div class="filter-container">
      <el-input v-model="listQuery.ip" :placeholder="langTxt('IP搜索')" style="width: 200px" />
      <el-date-picker class="filter-item" v-model="dateTime" type="datetimerange" :range-separator="langTxt('至')" :start-placeholder="langTxt('开始时间')" value-format="timestamp" @keyup.enter.native="handleFilter" :end-placeholder="langTxt('结束时间')"></el-date-picker>
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">
        {{ langTxt('搜索') }}
      </el-button>
    </div>
    <el-table v-loading="listLoading" :data="list" border fit highlight-current-row :height="height">
      <el-table-column show-overflow-tooltip :label="langTxt('ID')" prop="id"></el-table-column>
      <el-table-column show-overflow-tooltip :label="langTxt('IP')">
        <template slot-scope="{ row }">
          <el-button type="success" size="mini" icon="el-icon-document-copy" @click="copyLine(row.ip)">
            {{ row.ip }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip :label="langTxt('归属地')" prop="ip_addr"> </el-table-column>
      <el-table-column show-overflow-tooltip :label="langTxt('时间')" prop="ctime"> </el-table-column>

      <el-table-column width="120" :label="langTxt('状态')">
        <template slot-scope="{ row }">
          <el-tag :type="row.state | statusFilter">
            {{ row.state | stateTxt }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column :label="langTxt('操作')" width="120" class-name="small-padding fixed-width">
        <template slot-scope="{ row, $index }">
          <el-button type="text" size="mini" @click="handleDelete(row, $index)">{{ langTxt('拉黑') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- // 分页 -->
    <pagination v-if="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.pagesize" @pagination="getList" />
  </div>
</template>
<script>
  export default {
    name: 'IPsList',
    filters: {
      statusFilter(status) {
        const statusMap = {
          0: 'success',
          1: 'success',
          2: 'danger'
        };
        return statusMap[status];
      },
      stateTxt(status) {
        const statusMap = {
          0: '正常',
          1: '正常',
          2: '已拉黑'
        };
        return statusMap[status];
      }
    },
    data() {
      return {
        list: null,
        listLoading: true,
        listQuery: {
          page: 1,
          pagesize: 20
        },
        total: 0,
        dateTime: '',
        // eslint-disable-next-line vue/no-reserved-keys
        __i18n: {}
      };
    },
    computed: {
      height() {
        return this.$baseTableHeight();
      }
    },

    created() {
      this.getList();
      this.__i18n = this.$i18n.messages[this._i18n.locale];
    },
    methods: {
      // 搜索
      handleFilter() {
        this.listQuery.page = 1;
        if (this.dateTime) {
          var times = this.dateTime;
          this.listQuery.ctime = Math.round(times[0] / 1000);
          this.listQuery.etime = Math.round(times[1] / 1000);
        } else {
          delete this.listQuery.ctime;
          delete this.listQuery.etime;
        }
        this.getList();
      },

      // 获取列表
      getList() {
        this.listLoading = true;
        this.request
          .get('/ip-list', {
            params: this.listQuery
          })
          .then((ret) => {
            this.list = ret.list;
            this.total = ret.count;
            setTimeout(() => {
              this.listLoading = false;
            }, 200);
          });
      },
      // 复制推广链接
      copyLine(link) {
        this.$copyText(link).then(
          () => {
            this.$message({
              message: this.langTxt('复制成功'), //"复制成功"
              type: 'success'
            });
          },
          () => {
            this.$message.error(this.langTxt('复制失败')); //"复制失败"
          }
        );
      },

      // 拉黑操作
      handleDelete(row, index) {
        this.$baseConfirm('确定拉黑该IP?', '提示', async () => {
          this.request.post('/ipblack-add', row).then(() => {
            this.$message.success('IP已被拉黑');
            row.state = 2;
            this.list.splice(index, 1, row);
          });
        });
      }
    }
  };
</script>
